// removed by extract-text-webpack-plugin
module.exports = {"card":"_2Sgvfp41rNZbWR3oGKBjVu","header":"_2chX7zl38ZlGsH5uInr0lw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Card/style.scss
// module id = 876
// module chunks = 1